export const environment = {
    production: true,
    profile: 'dev',

    sandbox_logo_white: '/assets/icons/sandbox_logo_white.svg',

    // product logos
    ic_sbox_brackets: '/assets/icons/ic_sbox_brackets.svg',
    login_background: '/assets/images/login_background.svg',

    // endpoints
    auth_services_endpoint: 'https://keq7mx11sf.execute-api.ap-south-1.amazonaws.com/dev',
    authentication_host: 'https://dev1-accounts.sandbox.co.in',
    silo_url: 'https://dev-api.silo.quicko.company',
    silo_environment: 'dev',
    sandbox_console_host: 'https://dev-console.sandbox.co.in/',
    cognito_domain: 'https://sandbox.auth.ap-south-1.amazoncognito.com',
    cognito_client_id: '21m7bl6mdm2uomv041c6pem5k6',
    login_url: 'https://dev1-accounts.sandbox.co.in/login',
    token_issuer: 'https://cognito-idp.ap-south-1.amazonaws.com/ap-south-1_hq20ltKE2'

};
